import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { Checkbox, Chip, IconButton, Input, Menu, MenuItem, Paper, TextField, Tooltip, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import withReducer from 'app/store/withReducer';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdAdd, MdSearch } from 'react-icons/md';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/FilterActions';
import FilterReducer from './Store/Reducers/FilterReducer';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        padding: '5px 4px',
        display: 'flex',
        alignItems: 'center',
        height: '57px',
        border: '1px solid ' + theme.palette.divider,
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
    layoutRoot: {},
    spanlabel: {
        top: 9,
        left: 10,
        position: 'relative',
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        color: theme.palette.text.secondary,
        fontFamily: 'Muli,Roboto,"Helvetica",Arial,sans-serif'

    },
    rootTheme: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
    },
    panelConditions: {
        position: 'absolute',
        height: 56,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
        top: -56,
        width: '100%',
        minWidth: '100%',
        bottom: 0,
        left: 0,
        margin: 0,
        zIndex: 1000,
        '&.opened': {
            transform: 'translateX(0)',
            top: 0
        }
    },
    panel: {
        position: 'absolute',
        height: 72,
        backgroundColor: theme.palette.primary.main,
        boxShadow: theme.shadows[3],
        top: -72,
        width: '100%',
        minWidth: '100%',
        bottom: 0,
        left: 0,
        margin: 0,
        zIndex: 1000,
        '&.opened': {
            transform: 'translateX(0)',
            top: 0
        }
    },
    panelMobile: {
        position: 'absolute',
        height: 128,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
        top: -128,
        width: '100%',
        minWidth: '100%',
        bottom: 0,
        left: 0,
        margin: 0,
        zIndex: 1000,
        '&.opened': {
            transform: 'translateX(0)',
            top: 0
        }
    },
    panelMobileAvancado: {
        position: 'absolute',
        height: 325,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
        top: -325,
        width: '100%',
        minWidth: '100%',
        bottom: 0,
        left: 0,
        margin: 0,
        zIndex: 1000,
        '&.opened': {
            transform: 'translateX(0)',
            top: 0
        }
    }
});

const stringOperador = [
    { "nome": "Igual", "operador": "=" },
    { "nome": "Diferente", "operador": "<>" },
    { "nome": "Contém", "operador": "LIKE" }
];

const intOperador = [
    { "nome": "Igual", "operador": "=" },
    { "nome": "Diferente", "operador": "<>" },
    { "nome": "Maior", "operador": ">" },
    { "nome": "Menor", "operador": "<" }
];

const dateOperador = [
    { "nome": "Igual", "operador": "=" },
    { "nome": "Diferente", "operador": "<>" },
    { "nome": "Maior", "operador": ">" },
    { "nome": "Menor", "operador": "<" },
];

const NewCondicao = {
    campo: '',
    operador: '',
    valor: '',
    AND: null,
    OR: null,
    actionMenuEl: null
}

class FilterApp extends XAPPComponent {

    state = {
        form: NewCondicao,
        operadores: [{ "": "" }],
        searchType: 0,
        searchText: ''
    };

    componentDidMount() {
        if (!_.isNull(this.props.default)) {
            this.setState({});
        }
    }

    handleCheck = () => {
        this.setState({ searchType: this.state.searchType === 1 ? 0 : 1 });
    };

    addCondicao = (form) => {
        var newItem = { "campo": form.campo.value, "operador": form.operador, "valor": form.valor.toUpperCase(), "label": (form.campo.label + " " + form.operador + " " + form.valor) };
        var bexist = false;
        var AForm = this.state.form;
        form.AND !== null && form.AND.forEach(element => {
            if (this.isEquivalent(element, newItem))
                bexist = true;
        });
        if (!bexist) {
            var AArray = [];
            if (this.state.form.AND !== null) {
                AArray = this.state.form.AND;
            }
            AArray.push(newItem);
            AForm.AND = AArray;
            this.setState({ form: AForm });
            this.clearCampos();
        }
    }

    isEquivalent = (a, b) => {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
        if (aProps.length !== bProps.length)
            return false;
        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];
            if (a[propName] !== b[propName])
                return false;
        }
        return true;
    }

    clearCampos = () => {
        var obj = this.state.form;
        obj.campo = '';
        obj.operador = '';
        obj.valor = '';
        this.setState({ form: obj });
    }

    clearConditions = () => {
        this.setState({ form: NewCondicao, searchText: '' });
        this.props.pesquisar(this.props.default);
    }

    closePainel = () => {
        this.props.togglePainel();
    }

    pesquisar = (_AFilters) => {
        if (this.canBeAdd(_AFilters)) {
            this.addCondicao(_AFilters);
        }
        this.props.pesquisar(_AFilters);
    }

    delCondicao = (form, item, option) => {
        var state = this.state.form;
        var bexist = false;
        form.forEach(element => {
            if (this.isEquivalent(element, item))
                bexist = true;
        });

        if (bexist) {
            var ACondicoes = form;
            ACondicoes = ACondicoes.filter(function (ele) {
                return ele !== item;
            });
            state[option] = ACondicoes;
            this.setState({ form: state });
        }
        this.clearCampos();
        this.pesquisar(state);
    }

    setStateOperadores = (_ACampo) => {

        if (_ACampo.tipo === "string")
            this.setState({ operadores: stringOperador });
        else if (_ACampo.tipo === "int")
            this.setState({ operadores: intOperador });
        else if (_ACampo.tipo === "date")
            this.setState({ operadores: dateOperador });
        else
            this.setState({ operadores: [] });
    }

    handleChangeCampo = (event) => {
        this.setState({ form: _.set({ ...this.state.form }, event.target.name, event.target.value) });
        this.setStateOperadores(event.target.value);
    };

    handleChange = (event) => {
        this.setState({ form: _.set({ ...this.state.form }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value) });
    };

    handleMenuOpen = (event) => {
        this.setState({ form: _.set({ ...this.state.form }, "actionMenuEl", event.currentTarget) });
    };

    handleMenuClose = (event) => {
        this.setState({ form: _.set({ ...this.state.form }, "actionMenuEl", null) });
    };

    setSearchText = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
        var ACondicoes = [];

        if (event.target.value === "") {
            ACondicoes = null;
        }
        else {
            this.props.filters.forEach(item => {
                if (item.tipo === "int") {
                    if (Helpers.ParseInt(event.target.value, false)) {
                        ACondicoes.push({ "campo": item.value, "operador": " = ", "valor": event.target.value, "label": (item.label + " = " + event.target.value) });
                    }
                }
                else if (item.tipo === "date") {
                    if (Helpers.ParseDate(event.target.value)) {
                        ACondicoes.push({ "campo": item.value, "operador": " = ", "valor": event.target.value, "label": (item.label + " = " + event.target.value) });
                    }
                }
                else if (item.tipo === "string") {
                    if (event.target.value.length > 0) {
                        ACondicoes.push({ "campo": item.value, "operador": "LIKE", "valor": event.target.value.toUpperCase(), "label": (item.label + " = " + event.target.value) });
                    }
                }
            });
        }
        this.setState({ form: _.set({ ...this.state.form }, "OR", ACondicoes) });
    };

    canBeAdd = (_AForm) => {
        return (
            _AForm.campo !== null && _AForm.campo !== '' &&
            _AForm.operador !== null && _AForm.operador !== '' &&
            _AForm.valor !== null && _AForm.valor !== ''
        );
    }

    canBeSearch = (_AForm) => {
        return (
            ((_AForm.campo !== null && _AForm.campo !== '' &&
                _AForm.operador !== null && _AForm.operador !== '' &&
                _AForm.valor !== null && _AForm.valor !== '') ||
                ((_AForm.AND !== null && _AForm.AND.length > 0) || (_AForm.OR !== null && _AForm.OR.length > 0)))
        );
    }

    render() {
        const { searchText, searchType, form, operadores } = this.state;
        const { classes, button, pesquisaAvancada = true } = this.props;
        const CamposFilter = this.props.filters;

        return (
            <React.Fragment>
                {md.mobile() === null && md.tablet() === null ? (
                    <div className={classNames(classes.panel, { 'opened': button }, "flex flex-col")}>
                        <div className="flex flex-1 items-center justify-center px-12 py-12">
                            {searchType === 1 ? (
                                <div className="flex w-4/5">
                                    <div className="flex w-full h-full">
                                        <div className="flex flex-row w-full">
                                            <div className="flex flex-row w-full flex-wrap">
                                                <FuseAnimate animation="transition.slideDownIn" delay={300}>
                                                    <Paper className={classNames(classes.rootTheme, "flex items-center w-full pl-4 rounded-8")} elevation={1}>
                                                        <TextField
                                                            className="mr-8 mb-8"
                                                            label={'Campo'}
                                                            id="campo"
                                                            name="campo"
                                                            value={form.campo}
                                                            style={{ width: '25%' }}
                                                            onChange={this.handleChangeCampo}
                                                            select
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        >
                                                            {CamposFilter && CamposFilter.map((item) => (<MenuItem value={item}>{item.label}</MenuItem>))}
                                                        </TextField>
                                                        <TextField
                                                            className="mr-8 mb-8"
                                                            style={{ width: '25%' }}
                                                            label={'Operador'}
                                                            id="operador"
                                                            name="operador"
                                                            value={form.operador}
                                                            onChange={this.handleChange}
                                                            select
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        >
                                                            {operadores.map((item) => (<MenuItem value={item.operador}>{item.nome}</MenuItem>))}
                                                        </TextField>
                                                        <TextField
                                                            className="mb-8"
                                                            style={{ width: '35%' }}
                                                            label={'Valor'}
                                                            id="valor"
                                                            name="valor"
                                                            value={form.valor}
                                                            onChange={this.handleChange}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                        <div
                                                            className="flex"
                                                            style={{ width: '20%' }}
                                                        >
                                                            <Tooltip
                                                                title="Adicionar filtro"
                                                            >
                                                                <IconButton
                                                                    className="whitespace-no-wrap"
                                                                    onClick={() => this.addCondicao(form)}
                                                                    disabled={!this.canBeAdd(form)}
                                                                >
                                                                    <MdAdd className="text-24 text-white" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip
                                                                title="Pesquisar"
                                                            >
                                                                <IconButton
                                                                    className="whitespace-no-wrap"
                                                                    onClick={() => this.pesquisar(form)}
                                                                    disabled={!this.canBeSearch(form)}
                                                                >
                                                                    <MdSearch />
                                                                </IconButton>
                                                            </Tooltip>
                                                            {form.AND !== null && form.AND.length > 0 && (
                                                                <div style={{ width: '20%' }}>
                                                                    <Tooltip
                                                                        title="Ver filtros"
                                                                    >
                                                                        <IconButton
                                                                            aria-owns={form.actionMenuEl ? 'label-menu' : null}
                                                                            aria-haspopup="true"
                                                                            onClick={this.handleMenuOpen}
                                                                            id={"icon-menu"}
                                                                        >
                                                                            <Typography className="text-18">{"(" + form.AND.length + ")"}</Typography>

                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Menu
                                                                        id={"label-menu"}
                                                                        anchorEl={form.actionMenuEl}
                                                                        open={form.actionMenuEl !== null && Object.keys(form.actionMenuEl).length > 0}
                                                                        onClose={this.handleMenuClose}
                                                                    >
                                                                        {form.AND !== null && form.AND.length > 0 && form.AND.map(item => (
                                                                            <MenuItem>
                                                                                <Chip
                                                                                    label={item.label}
                                                                                    onDelete={() => this.delCondicao(form.AND, item, 'AND')}
                                                                                    className="mr-8 my-8"
                                                                                    classes={{ label: "pl-4" }}
                                                                                    key={item}
                                                                                />
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Menu>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Paper>
                                                </FuseAnimate>
                                            </div>
                                        </div>
                                    </div>
                                    {pesquisaAvancada &&
                                        <Tooltip
                                            title="Pesquisa avançada"
                                        >
                                            <Checkbox
                                                checked={searchType}
                                                color="inherit"
                                                onClick={event => event.stopPropagation()}
                                                onChange={event => this.handleCheck()}
                                                className={"text-white"}
                                            />
                                        </Tooltip>
                                    }
                                    <XAPPButton
                                        tooltip={{ "title": "Limpar filtros", "placement": "top" }}
                                        type="icon"
                                        onClick={() => this.clearConditions()}
                                        icon={"clear"}
                                        iconProps={"text-white"}
                                    />
                                    <XAPPButton
                                        tooltip={{ "title": "Fechar pesquisa", "placement": "top" }}
                                        type="icon"
                                        onClick={() => this.closePainel()}
                                        icon={"close"}
                                        iconProps={"text-white"}
                                    />
                                </div>
                            ) : (
                                <div className="flex w-4/5">
                                    <div className="flex w-full">
                                        <FuseAnimate animation="transition.slideDownIn" delay={300}>
                                            <Paper className={classNames(classes.rootTheme, "flex items-center w-full p-4 rounded-8")} elevation={1}>
                                                <Input
                                                    placeholder="Pesquisar"
                                                    className="flex w-full "
                                                    disableUnderline
                                                    fullWidth
                                                    autoFocus
                                                    name="searchText"
                                                    value={searchText}
                                                    inputProps={{
                                                        'aria-label': 'Pesquisar'
                                                    }}
                                                    onChange={this.setSearchText}
                                                    onKeyPress={(ev) => {
                                                        if (ev.charCode === 13) {
                                                            this.pesquisar(form)
                                                        }
                                                    }}
                                                />
                                                <Tooltip
                                                    title="Pesquisar"
                                                >
                                                    <IconButton
                                                        className="whitespace-no-wrap"
                                                        onClick={() => this.pesquisar(form)}
                                                        disabled={!this.canBeSearch(form)}
                                                    >
                                                        <MdSearch />
                                                    </IconButton>
                                                </Tooltip>
                                            </Paper>
                                        </FuseAnimate>
                                    </div>
                                    {pesquisaAvancada &&
                                        <Tooltip
                                            title="Pesquisa avançada"
                                        >
                                            <Checkbox
                                                checked={searchType}
                                                color="inherit"
                                                onClick={event => event.stopPropagation()}
                                                onChange={event => this.handleCheck()}
                                                className={"text-white"}
                                            />
                                        </Tooltip>
                                    }
                                    <XAPPButton
                                        tooltip={{ "title": "Limpar filtros", "placement": "top" }}
                                        type="icon"
                                        onClick={() => this.clearConditions()}
                                        icon={"clear"}
                                        iconProps={"text-white"}
                                    />
                                    <XAPPButton
                                        tooltip={{ "title": "Fechar pesquisa", "placement": "top" }}
                                        type="icon"
                                        onClick={() => this.closePainel()}
                                        icon={"close"}
                                        iconProps={"text-white"}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className={classNames(searchType === 1 ? classes.panelMobileAvancado : classes.panelMobile, { 'opened': button }, "flex flex-col")}>
                        <div className="items-center justify-center px-12 py-12">
                            <div className="flex w-full">
                                <Typography
                                    className="text-14 pt-12"
                                    color="inherit"
                                >
                                    Pesquisa avançada
                                </Typography>

                                {pesquisaAvancada &&
                                    <Tooltip
                                        title="Pesquisa avançada"
                                    >
                                        <Checkbox
                                            checked={searchType}
                                            color="inherit"
                                            onClick={event => event.stopPropagation()}
                                            onChange={event => this.handleCheck()}
                                            className={"text-white"}
                                        />
                                    </Tooltip>
                                }
                                <div className="flex-1" />
                                <XAPPButton
                                    tooltip={{ "title": "Limpar filtros", "placement": "top" }}
                                    type="icon"
                                    onClick={() => this.clearConditions()}
                                    icon={"clear"}
                                    iconProps={"text-white"}
                                />
                                <XAPPButton
                                    tooltip={{ "title": "Fechar pesquisa", "placement": "top" }}
                                    type="icon"
                                    onClick={() => this.closePainel()}
                                    icon={"close"}
                                    iconProps={"text-white"}
                                />
                            </div>
                            {searchType === 1 ? (
                                <div className="flex flex-row w-full">
                                    <div className="flex flex-row w-full flex-wrap">
                                        <FuseAnimate animation="transition.slideDownIn" delay={300}>
                                            <Paper className={classNames(classes.rootTheme, "items-center w-full p-4 rounded-8 ")} elevation={1}>
                                                {form.AND !== null && form.AND.length > 0 && (
                                                    <div className="flex w-full items-center justify-center">
                                                        <IconButton
                                                            aria-owns={form.actionMenuEl ? 'label-menu' : null}
                                                            aria-haspopup="true"
                                                            onClick={this.handleMenuOpen}
                                                            id={"icon-menu"}
                                                        >
                                                            <Typography className="text-18">{" Condições: (" + form.AND.length + ")"}</Typography>

                                                        </IconButton>
                                                        <Menu
                                                            id={"label-menu"}
                                                            anchorEl={form.actionMenuEl}
                                                            open={Boolean(form.actionMenuEl)}
                                                            onClose={this.handleMenuClose}
                                                        >
                                                            {form.AND !== null && form.AND.length > 0 && form.AND.map(item => (
                                                                <MenuItem>
                                                                    <Chip
                                                                        label={item.label}
                                                                        onDelete={() => this.delCondicao(form.AND, item, 'AND')}
                                                                        className="mr-8 my-8"
                                                                        classes={{ label: "pl-4" }}
                                                                        key={item}
                                                                    />
                                                                </MenuItem>
                                                            ))}
                                                        </Menu>
                                                    </div>
                                                )}
                                                <div className="flex">
                                                    <TextField
                                                        fullWidth
                                                        label={'Campo'}
                                                        id="campo"
                                                        name="campo"
                                                        value={form.campo}
                                                        onChange={this.handleChangeCampo}
                                                        select
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    >
                                                        {CamposFilter && CamposFilter.map((item) => (<MenuItem value={item}>{item.label}</MenuItem>))}
                                                    </TextField>
                                                </div>
                                                <div className="flex">
                                                    <TextField
                                                        fullWidth
                                                        label={'Operador'}
                                                        id="operador"
                                                        name="operador"
                                                        value={form.operador}
                                                        onChange={this.handleChange}
                                                        select
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    >
                                                        {operadores.map((item) => (<MenuItem value={item.operador}>{item.nome}</MenuItem>))}
                                                    </TextField>
                                                </div>
                                                <div className="flex">
                                                    <TextField
                                                        fullWidth
                                                        label={'Valor'}
                                                        id="valor"
                                                        name="valor"
                                                        value={form.valor}
                                                        onChange={this.handleChange}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex">
                                                    <div className="flex-1" />
                                                    <Tooltip
                                                        title="Adicionar filtro"
                                                    >
                                                        <IconButton
                                                            className="whitespace-no-wrap"
                                                            onClick={() => this.addCondicao(form)}
                                                            disabled={!this.canBeAdd(form)}
                                                        >
                                                            <MdAdd className="text-24 text-white" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip
                                                        title="Pesquisar"
                                                    >
                                                        <IconButton
                                                            className="whitespace-no-wrap"
                                                            onClick={() => this.pesquisar(form)}
                                                            disabled={!this.canBeSearch(form)}
                                                        >
                                                            <MdSearch />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </Paper>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex">
                                    <div className="flex w-full">
                                        <FuseAnimate animation="transition.slideDownIn" delay={300}>
                                            <Paper className={classNames(classes.rootTheme, "flex items-center w-full p-4 rounded-8")} elevation={1}>
                                                <Input
                                                    placeholder="Pesquisar"
                                                    className="flex  w-full "
                                                    disableUnderline
                                                    fullWidth
                                                    autoFocus
                                                    name="searchText"
                                                    value={searchText}
                                                    inputProps={{
                                                        'aria-label': 'Pesquisar'
                                                    }}
                                                    onChange={this.setSearchText}
                                                    onKeyPress={(ev) => {
                                                        if (ev.charCode === 13) {
                                                            this.pesquisar(form)
                                                        }
                                                    }}
                                                />
                                                <Tooltip
                                                    title="Pesquisar"
                                                >
                                                    <IconButton
                                                        className="whitespace-no-wrap"
                                                        onClick={() => this.pesquisar(form)}
                                                        disabled={!this.canBeSearch(form)}
                                                    >
                                                        <MdSearch />
                                                    </IconButton>
                                                </Tooltip>
                                            </Paper>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div className={classNames(classes.panelConditions, { 'opened': md.mobile() !== null && !button && form.AND !== null && form.AND.length > 0 }, "flex flex-col")}>
                    <div className="items-center justify-center p-12">
                        {form.AND !== null && form.AND.length > 0 && (
                            <div className="flex items-center justify-center">
                                <IconButton
                                    aria-owns={form.actionMenuEl ? 'label-menu' : null}
                                    aria-haspopup="true"
                                    onClick={this.handleMenuOpen}
                                    id={"icon-menu"}
                                >
                                    <Typography className="text-18">{"Condições: (" + form.AND.length + ")"}</Typography>

                                </IconButton>
                                <Menu
                                    id={"label-menu"}
                                    anchorEl={form.actionMenuEl}
                                    open={Boolean(form.actionMenuEl)}
                                    onClose={this.handleMenuClose}
                                >
                                    {form.AND !== null && form.AND.length > 0 && form.AND.map(item => (
                                        <MenuItem>
                                            <Chip
                                                label={item.label}
                                                onDelete={() => this.delCondicao(form.AND, item, 'AND')}
                                                className="mr-8 my-8"
                                                classes={{ label: "pl-4" }}
                                                key={item}
                                            />
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </div>
                        )}
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        togglePainel: Actions.togglePainel,
    }, dispatch);
}

function mapStateToProps({ FilterApp }) {
    return {
        Filter: FilterApp,
        button: FilterApp.button,
    }
}

export default withReducer('FilterApp', FilterReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterApp))));
